<template>
    <div>
        <!-- Section header -->
        <div class="mb-4">
            <!-- Title with the due date to the side. -->
            <div class="flex items-center justify-between gap-2">
                <h2 class="scaffold-body truncate">{{ selfTitle }}</h2>
                <span v-if="dateLabel" class="scaffold-body-small text-ink-muted whitespace-nowrap shrink-0">{{ dateLabel }}</span>
            </div>
            <!-- Optional sub-copy below the title. -->
            <p v-if="selfSubtitle" class="scaffold-body-small text-ink-muted mt-1 whitespace-pre-line">{{ selfSubtitle }}</p>
        </div>
        <!-- Review rows (no accordion — the self section always shows its rows directly) -->
        <div class="rounded-xl flex flex-col bg-surface-raised border border-border">
            <PerformanceManagementCTA
                v-for="review in reviews"
                :key="review.id"
                :review="review"
                class="px-5"
                :is-loading="!!currentReviewId && currentReviewId === review.id"
                :is-disabled="!!currentReviewId && currentReviewId !== review.id"
                :is-moment-read-only="isMomentReadOnly"
                :is-coming-soon="isSectionLocked"
                @cta-convo-clicked="(reviewId) => $emit('cta-convo-clicked', reviewId)"
                @completion-toggled="(reviewId, complete) => $emit('completion-toggled', reviewId, complete)" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { formatSectionDateLabel, isStartDateInFuture } from "~vue/composables/useCtaDateRange";
import type { DecoratedPerformanceReview } from "~vue/types/performance_management";
import { computed } from "vue";

import PerformanceManagementCTA from "./PerformanceManagementCTA.vue";

const props = withDefaults(
    defineProps<{
        dueDate?: string | null;
        startDate?: string | null;
        selfTitle?: string;
        selfSubtitle?: string;
        reviews: DecoratedPerformanceReview[];
        currentReviewId?: string | null;
        isMomentReadOnly?: boolean;
    }>(),
    {
        selfTitle: "",
        selfSubtitle: "",
        currentReviewId: null,
    },
);

defineEmits(["cta-convo-clicked", "completion-toggled"]);

const dateLabel = computed(() => formatSectionDateLabel(props.startDate, props.dueDate));

// Section hasn't opened yet — disable/grey its CTAs until the start date arrives.
const isSectionLocked = computed(() => isStartDateInFuture(props.startDate));
</script>
